import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-c6f1e7c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = { class: "table-responsive" };
const _hoisted_3 = { class: "table-wrapper" };
const _hoisted_4 = { class: "table-title" };
const _hoisted_5 = { class: "row" };
const _hoisted_6 = { class: "content_edit" };
const _hoisted_7 = { class: "input-group" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "Name", -1));
const _hoisted_9 = { class: "input-group" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "input-group-text" }, "Mode", -1));
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "aligned" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "adding_item" }, "Change User", -1));
const _hoisted_14 = [
    _hoisted_13
];
import 'vue-final-modal/style.css';
import '../../assets/styles/boot.min.css';
import '../../assets/styles/font.min.css';
import { ref, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import api from '../../api';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditorUser',
    props: {
        title: String,
        item: null
    },
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const props = __props;
        const options = ref([
            { text: 'admin', value: 'admin' },
            { text: 'editor', value: 'editor' },
            { text: 'visitor', value: 'visitor' }
        ]);
        const users = ref([]);
        const user = ref({ name: '', mode: '', email: '' });
        const selected = ref('admin');
        const name = ref('');
        const isAble = ref(false);
        console.log(props.item);
        console.log(router);
        // // Extract the query parameter 'item'
        // const itemId = computed(() => {
        //   // 'item' is the query parameter name
        //   return route.query.item || 'No ID provided';
        // });
        const itemId = route.query.item;
        // Fetch users data
        const fetchUsers = async () => {
            console.log('fecth');
            try {
                const response = await api.get('user_list.php', {
                    params: { id: itemId }
                });
                if (response.data.status === 'success') {
                    users.value = response.data.list;
                    user.value = users.value[0];
                    selected.value = user.value.mode;
                    name.value = user.value.name;
                }
                //
            }
            catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
        const change = async () => {
            try {
                console.log(selected.value, '   xxx   ', name.value);
                const formData = new FormData();
                formData.append('email', user.value.email);
                formData.append('mode', selected.value);
                formData.append('name', name.value);
                console.log(formData);
                const response = await api.post('edit_user.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                if (response.data.status === 'success') {
                    console.log('User edit successfully');
                    router.push('users');
                    // Refresh user list or handle success
                }
                else {
                    console.error('Error edit user:', response.data.message);
                    router.push('users');
                }
            }
            catch (error) {
                console.error('Request error:', error);
                router.push('users');
            }
        };
        // Watch the `name` ref and update `isAble` accordingly
        watch(name, (newName, oldName) => {
            console.log(newName, oldName);
            if (newName === "") {
                isAble.value = false;
            }
            else {
                isAble.value = true;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", null, [
                                    _createTextVNode("Edit > "),
                                    _createElementVNode("b", null, _toDisplayString(user.value.email), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "basic-url",
                                    "aria-describedby": "basic-addon3 basic-addon4",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((name).value = $event))
                                }, null, 512), [
                                    [_vModelText, name.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selected).value = $event))
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: option.value,
                                            key: option.text
                                        }, _toDisplayString(option.text), 9, _hoisted_11));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, selected.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("button", {
                                    class: _normalizeClass([isAble.value ? '' : 'disabled', "btn btn-primary btn-block confirm_btn"]),
                                    onClick: change
                                }, _hoisted_14, 2)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
